import classNames from "classnames";

import MoonIcon from "assets/icons/MoonIcon";
import useDragging from "hooks/useDragging";
import SunIcon from "assets/icons/SunIcon";

import styles from "./style.module.scss";
import { useThemeContext } from "../../providers/ThemeProvider";

export enum THEME {
  LIGHT = "light",
  DARK = "dark",
}

const ThemeToggle = () => {
  const { theme, onThemeChange } = useThemeContext();
  const isDark = theme === THEME.DARK;

  const onDragComplete = (dragOffset: number) => {
    if (dragOffset > 10) {
      onThemeChange(THEME.LIGHT);
    } else if (dragOffset < -10) {
      onThemeChange(THEME.DARK);
    }
  };

  const { isDragging, handleMouseDown } = useDragging({
    onDragComplete,
    threshold: 10,
  });

  const containerClassnames = classNames(styles.toggleContainer, {
    [styles.grabbing]: isDragging,
  });

  const darkIconClassnames = classNames(styles.iconContainer, {
    [styles.active]: isDark,
  });

  const lightIconClassnames = classNames(styles.iconContainer, {
    [styles.active]: !isDark,
  });

  const sliderClassnames = classNames(
    styles.slider,
    isDark ? styles.leftAlign : styles.rightAlign,
    { [styles.grabbing]: isDragging },
  );

  return (
    <div className={containerClassnames} data-testid="theme-toggle-container">
      <div
        className={sliderClassnames}
        data-testid="theme-toggle-slider"
        onMouseDown={handleMouseDown}
      ></div>
      <div
        className={darkIconClassnames}
        onClick={() => onThemeChange(THEME.DARK)}
        data-testid="dark-theme-icon"
      >
        <MoonIcon />
      </div>
      <div
        className={lightIconClassnames}
        onClick={() => onThemeChange(THEME.LIGHT)}
        data-testid="light-theme-icon"
      >
        <SunIcon />
      </div>
    </div>
  );
};

export default ThemeToggle;
